import React from 'react';
import { INPUT, INPUT_SM } from './uiTokens';
import type { TextInputProps } from './types/UIProps';

export type { TextInputProps };

export function TextInput({
  inputSize = 'md',
  label,
  error,
  className = '',
  id,
  ...rest
}: TextInputProps): React.ReactElement {
  const inputId = id ?? (label ? `input-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  const token = inputSize === 'sm' ? INPUT_SM : INPUT;

  const field = (
    <input
      id={inputId}
      className={`${token} ${error ? 'border-red-400 focus:border-red-500 focus:ring-red-500/20' : ''} ${className}`.trim()}
      aria-invalid={error ? true : undefined}
      {...rest}
    />
  );

  if (!label && !error) return field;

  return (
    <div className="flex flex-col gap-1">
      {label ? (
        <label htmlFor={inputId} className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 dark:text-slate-400">
          {label}
        </label>
      ) : null}
      {field}
      {error ? <p className="text-[11px] text-red-600 dark:text-red-400">{error}</p> : null}
    </div>
  );
}
